export default function PHP_ftp_alloc() {
  return (
    <div>
      <h1>PHP_ftp_alloc</h1>
    </div>
  );
}
